import { T } from '@angular/cdk/keycodes';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'app/core/services/api.service';
import { CustomFieldServiceService } from 'app/core/services/custom-field.service';
import { ProspectStatusServiceService } from 'app/core/services/prospect-status.service';
import { UnifiedInboxService } from 'app/core/services/unified-inbox.service';
import { UtilService } from 'app/core/services/util.service';

@Component({
    selector: 'add-prospect-status',
    templateUrl: './add-prospect-status.component.html',
    styleUrls: [],
})
export class AddProspectStatusComponent implements OnInit {
    isaddEditStatus: boolean = false;
    @Input() activaPage: 'prospect_status' | 'inbox' = 'prospect_status';
    constructor(
        public _prospectStatusSer: ProspectStatusServiceService,
        private _api: ApiService,
        private _util: UtilService,
        private _dialog: MatDialog,
        private _customFieldSer: CustomFieldServiceService,
        private _inboxser: UnifiedInboxService
    ) {}

    ngOnInit(): void {}

    changeColor(e) {
        this._prospectStatusSer.prospectStatusForm.controls['color'].setValue(
            e
        );
    }

    addUpdateProspectStatus() {
        Object.entries(
            this._prospectStatusSer.prospectStatusForm.controls
        ).forEach(([key, value]) => {
            this._prospectStatusSer.prospectStatusForm.controls[
                key
            ].markAsDirty();
            this._prospectStatusSer.prospectStatusForm.controls[
                key
            ].markAsTouched();
        });
        if (
            this.isaddEditStatus ||
            this._prospectStatusSer.prospectStatusForm.invalid
        )
            return;
        this.isaddEditStatus = true;
        const fd = new FormData();
        fd.append(
            'name',
            this._prospectStatusSer.prospectStatusForm.controls.name.value
        );
        fd.append(
            'interested_status',
            this._prospectStatusSer.prospectStatusForm.controls
                .interested_status.value
                ? this._prospectStatusSer.prospectStatusForm.controls
                      .interested_status.value
                : ''
        );
        fd.append(
            'color',
            this._prospectStatusSer.prospectStatusForm.controls.color.value
        );
        if (this._prospectStatusSer.typeOf == 'add') {
            this._api.postData('create-status', fd).subscribe({
                next: (res: any) => {
                    if (res.success) {
                        this._util.showToast(res.message);
                        if(this.activaPage == 'prospect_status') {
                            const date = new Date(res.data.created_at);
                                // Format the date
                                const options: Intl.DateTimeFormatOptions = {
                                    weekday: 'short',
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                };
                                res.data.dateFormate = date.toLocaleDateString(
                                    'en-US',
                                    options
                                );
                            this._prospectStatusSer.backupProspectStauts.push(res.data);
                            this._prospectStatusSer.allStatus.push(res.data);
                            this._prospectStatusSer.prospectAllStatus.data = Object.assign([], this._prospectStatusSer.backupProspectStauts);
                            this._customFieldSer.updatePagination(this._prospectStatusSer.prospectAllStatus)
                        } else {
                            this._inboxser.inboxSideNavAllData.status.push(res.data);
                        }
                        this._dialog.closeAll();
                    } else {
                        this._util.showToast(res.message, true);
                    }
                    this.isaddEditStatus = false;
                },
                error: (err) => {
                    console.log('err', err);
                    this.isaddEditStatus = false;
                    if (err instanceof Object) {
                        Object.entries(err).forEach(([key, value]) => {
                            switch (key) {
                                case 'name':
                                    this._prospectStatusSer.prospectStatusForm.controls[
                                        'name'
                                    ].setErrors({
                                        lv: value[0],
                                    });
                                    break;
                                case 'interested_status':
                                    this._prospectStatusSer.prospectStatusForm.controls[
                                        'interested_status'
                                    ].setErrors({
                                        lv: value[0],
                                    });
                                    break;
                                case 'interested_status':
                                    this._prospectStatusSer.prospectStatusForm.controls[
                                        'color'
                                    ].setErrors({
                                        lv: value[0],
                                    });
                            }
                        });
                    }
                },
                complete() {},
            });
        } else if (this._prospectStatusSer.typeOf == 'edit') {
            fd.append('id', this._prospectStatusSer.updateStatusData.id);
            this._api.postData('update-status', fd).subscribe({
                next: (res: any) => {
                    if (res.success) {
                        this._util.showToast(res.message);
                        this._dialog.closeAll();
                        console.log(
                            'this._prospectStatusSer.prospectAllStatus',
                            this._prospectStatusSer.prospectAllStatus
                        );
                        this._prospectStatusSer.prospectAllStatus.filteredData.forEach(
                            (status) => {
                                if (
                                    status.id ==
                                    this._prospectStatusSer.updateStatusData.id
                                ) {
                                  console.log({status});
                                  status.name = this._prospectStatusSer.prospectStatusForm.controls['name'].value;
                                  status.interested_status = this._prospectStatusSer.prospectStatusForm.controls['interested_status'].value;
                                  status.color = this._prospectStatusSer.prospectStatusForm.controls['color'].value;
                                }
                            }
                        );
                        this._prospectStatusSer.allStatus.forEach((status, ind) => {
                            if (status.id == this._prospectStatusSer.updateStatusData.id) {
                                status.name = this._prospectStatusSer.prospectStatusForm.controls['name'].value;
                                status.interested_status = this._prospectStatusSer.prospectStatusForm.controls['interested_status'].value;
                                status.color = this._prospectStatusSer.prospectStatusForm.controls['color'].value;
                            }
                        })
                    } else {
                        this._util.showToast(res.message, true);
                    }
                    this.isaddEditStatus = false;
                },
                error: (err) => {
                    console.log('err', err);
                    this.isaddEditStatus = false;
                    if (err instanceof Object) {
                        Object.entries(err).forEach(([key, value]) => {
                            switch (key) {
                                case 'name':
                                    this._prospectStatusSer.prospectStatusForm.controls[
                                        'name'
                                    ].setErrors({
                                        lv: value[0],
                                    });
                                    break;
                                case 'interested_status':
                                    this._prospectStatusSer.prospectStatusForm.controls[
                                        'interested_status'
                                    ].setErrors({
                                        lv: value[0],
                                    });
                                    break;
                                case 'interested_status':
                                    this._prospectStatusSer.prospectStatusForm.controls[
                                        'color'
                                    ].setErrors({
                                        lv: value[0],
                                    });
                            }
                        });
                    }
                },
                complete() {},
            });
        }
    }
}
